import { defineComponent } from 'vue';
import InfoIconWithTooltip from '@common/layout/InfoIconWithTooltip.vue';
import { BFormCheckbox } from 'bootstrap-vue';
import { translator } from '~/zf/frontend/common/mixins';
export default defineComponent({
    name: 'PreventionBehavior',
    components: { BFormCheckbox, InfoIconWithTooltip },
    compatConfig: {
        MODE: 3,
    },
    mixins: [translator],
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    computed: {
        preventionBehavior: {
            get() {
                return this.modelValue;
            },
            set(cascading) {
                this.$emit('update:modelValue', cascading);
            },
        },
    },
});
